import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { ChangePasswordRequest, ChangePasswordResponse, LoginApiResponse, LoginRequest } from '../../../../core/models/session.models';
import { SessionService } from '../../../../core/services/session.service';
import { AuthApiService } from './auth-api.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(
    private authApiService: AuthApiService,
    private sessionService: SessionService
  ) { }

  login(payload: LoginRequest): Observable<LoginApiResponse> {
    return this.authApiService.login(payload).pipe(
      tap(response => {
        this.sessionService.startSession(response);
      })
    );
  }

  logout(): void {
    this.sessionService.clearSession();
  }

  changePassword(payload: ChangePasswordRequest): Observable<ChangePasswordResponse> {
    return this.authApiService.changePassword(payload);
  }
}